export const verifyHeader = 'test'
export const backUpVerifyUrl = 'https://apimint.tst.gm.com/api-0201/webu/api/isValidToken'
export const backUpServerTimeUrl = 'https://apimint.tst.gm.com/api-0201/webu/api/currenttime'
